/*!
 * Copyright (C) 2013-2022, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *	2014-07-01
 *		- Fixed social icon clicks.
 *
 *	2015-10-06
 *		- Added GA tracking for clicking on a day of the calendar.
 *
 *	2016-03-21
 *		- Fixed tooltip code so links in the copy are now clickable.
 *
 *	2016-05-03
 *		- Fixed error with touchwipe code that was trying to preventDefault on a non-existant event object.
 *
 *	2016-12-29
 *		- Removed social icons from single-event dialogs.
 *
 *	2017-01-24
 *		- Added code to style input for email address in "Email Info" dialog.
 *
 *	2017-01-27
 *		- Removed mobile navigation code due to list output.
 *
 *	2017-02-21
 *		- Improve accessibility of dialogs via tabindex.
 *
 *	2018-02-13
 *		- Fixed issue with banner images having parenthesis in their file names.
 *
 *	20122-08-19
 *		- Refactored filter code from event-calendar.js to <calendar-filter-widget>.
 *		- Clean up code in event-calendar.js.
*/
(function ($) {

    'use strict';

    //DETECT OLD IE
    function getInternetExplorerVersion() {
        let rv = -1; // Return value assumes failure.
        if (navigator.appName === 'Microsoft Internet Explorer') {
            const ua = navigator.userAgent;
            const re = new RegExp("MSIE ([0-9]+[\.0-9]*)");
            if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
        }
        return rv;
    }

    const $calendarWrapper = $("#calendar-wrapper");
    const $events = $calendarWrapper.find(".event");
    const $calendarOverlay = $('#calendar-overlay');
    const ieVersion = getInternetExplorerVersion();
    const isOldIE = (ieVersion >= 6 && ieVersion < 8);
    const viewDayEventHeight = 145;

    if (isOldIE) {
        $calendarWrapper
            .addClass("textual-titles");
    }

    $(document).on("click", function () {
        $calendarWrapper
            .children(".tooltip, .view-day")
            .trigger("close");
    });

    $events
        .on("click", function (event) {

            const $this = $(this);

            if (!$this.hasClass('no-click') && !$('html').hasClass('ui-mobile')) {

                event.preventDefault();
                event.stopPropagation();

                //if ($this.hasClass("more")) {
                if ($this.parent().children('.event').length > 1) {

                    //track this click
                    window.pepTracking.event("Event Calendar", "Day Click (Multiple)", $this.closest('.calendar-day').data('date'), 0, false);

                    var $newEle = $('<div class="view-day" tabindex="0" />').data('hoverTimer', null).data('lastFocusedElement', document.activeElement),
                        $clones = $this.parent().children('.event').not(".more").clone(),
                        top = ($this.closest('td').position().top + ($this.closest('td').height() / 1.5)),
                        left = ($this.closest('td').position().left - 203 + $this.closest('td').width() / 2);

                    $clones
                        .find(".background-size-polyfill")
                        .remove();

                    setTimeout(function () {

                        for (var i = 0, l = $clones.length; i < l; i++) {

                            $clones
                                .eq(i)
                                .css({
                                    backgroundPosition: '',
                                    backgroundImage: 'url(\'' + $clones.eq(i).data('banner-img') + '\')',
                                    backgroundSize: ''
                                });

                        }

                        setTimeout(function () {

                            if (isOldIE) {

                                $clones.css({backgroundSize: 'contain'});

                            }

                        }, 250);

                    }, 250);

                    $clones.on("click", function (event) {

                        event.preventDefault();
                        event.stopPropagation();

                        window.location = $(this).find('a').attr('href');

                    });

                    $newEle
                        .append($clones)
                        .append('<div class="shadow"></div>');

                    if (top + $newEle.children().length * viewDayEventHeight > $calendarWrapper.height()) {

                        top = $calendarWrapper.height() - $newEle.children().length * viewDayEventHeight;

                    } else if (top < 0) {

                        top = 0;

                    }

                    if (left - 213 < 0) {

                        left = 0;

                    } else if (left + 406 > $calendarWrapper.width()) {

                        left = $calendarWrapper.width() - 406;

                    }

                    //setup close event handler
                    $newEle
                        .on("close", function () {

                            $newEle
                                .removeClass('active');

                            setTimeout(function () {

                                $newEle
                                    .remove();

                            }, 625);

                            $calendarOverlay
                                .removeClass("active");

                            $newEle
                                .data('lastFocusedElement')
                                .focus();

                        }).append(
                        $('<a class="close" href="#" title="Click to Close Window" />').text("Close").on("click", function () {

                            $newEle
                                .trigger("close");

                            return false;
                        })
                    );

                    //find center of .view-day element
                    $newEle
                        .css({
                            top: top,
                            left: left,
                            transform: 'translateX(' + ($this.closest('td').position().left - left) + 'px) translateY(' + ($this.closest('td').position().top - top) + 'px) scale(' + ($this.closest('td').outerWidth() / 406) + ', ' + ($this.closest('td').outerHeight() / ($newEle.children('.event').length * viewDayEventHeight)) + ')'
                        });

                    //close old popups
                    $calendarWrapper
                        .children('.view-day, .tooltip')
                        .trigger('close')
                        .end()
                        .append($newEle);

                    clearTimeout($calendarOverlay.data("timer"));

                    setTimeout(function () {

                        $calendarOverlay
                            .addClass("active");

                        $newEle
                            .addClass('active')
                            .css({
                                transform: ''
                            });

                    }, 50);

                } else {

                    //just follow the link if in the mobile ui
                    if ($("html").hasClass("ui-mobile")) {

                        event.preventDefault();
                        event.stopPropagation();

                        window.location = $this.children('a').attr('href');

                        return;
                    }

                    //track this click
                    window.pepTracking.event("Event Calendar", "Day Click (Single)", $this.closest('.calendar-day').data('date'), 0, false);

                    var eventCount = $this.closest('td').find('.event').length,
                        $tooltip = $('<div class="tooltip" tabindex="0" />')
                            .data('lastFocusedElement', document.activeElement)
                            .css({
                                backgroundImage: 'url(' + $this.data('banner-img') + ')'
                            })
                            .addClass('count-' + eventCount)
                            .on('click', function (event) {

                                event.stopPropagation();

                            }).on('close', function () {

                                $tooltip
                                    .removeClass('active')
                                    .css({
                                        transformOrigin: ''
                                    });

                                setTimeout(function () {

                                    $tooltip
                                        .remove();

                                }, 550);

                                $calendarOverlay
                                    .removeClass("active");

                                $tooltip
                                    .data('lastFocusedElement')
                                    .focus();

                            }).append(
                                $('<a class="close" href="#" title="Click to Close Window" />').text("Close").on("click", function (event) {

                                    event.preventDefault();
                                    event.stopPropagation();

                                    $tooltip
                                        .trigger("close");

                                })
                            ).append(
                                $('<h3 />').text($this.children('a').data('title'))
                            ).append(
                                $this.children('a').data('body')
                            ).append(
                                $('<div class="button-bar" />').append(
                                    $('<a class="btn close-btn" href="#" />').text('Close').on("click", function (event) {

                                        event.preventDefault();
                                        event.stopPropagation();

                                        $tooltip
                                            .trigger("close");

                                    })
                                ).append(
                                    $('<a class="btn more-info" href="' + $this.children('a').attr('href') + '" />').text('More Information').on("click", function (event) {

                                        event.preventDefault();
                                        event.stopPropagation();

                                        window.location = $(this).attr('href');

                                    })
                                ).append(
                                    $('<a class="btn email-info" href="' + $this.children('a').attr('href') + '#Email-Details" />').text('Email Details').on('click', function (event) {

                                        var $link = $(this);

                                        if ($link.data('lock')) return false;

                                        $link.data('lock', true);

                                        event.preventDefault();

                                        showOverlayDialog({
                                            confirmAccept: 'SEND',
                                            confirmDeny: 'CANCEL',
                                            confirmTitle: 'Email this event info?',
                                            confirmBody: 'Enter an email address to send the details of this event to the recipient.<br /><br /><form class="pepvalidate-v3 ajax-ignore"><p><label><span class="text">Email Address</span><input type="email" name="EMAIL_ADDRESS" /></label></p></form>',
                                            query: 'ACTION=SEND_EVENT_DETAILS&EVENT_ID=' + parseInt($this.data('id'), 10) + ''
                                        }, this);

                                    })
                                )
                            );

                    if (parseInt($this.children('a').data('i'), 10) === 0) {

                        $tooltip
                            .find(".email-info")
                            .css({display: 'none'});

                    }

                    //allow read-more links to not be prevented
                    $tooltip
                        .find('.read-more')
                        .on("click", function (event) {

                            event.stopPropagation();

                        });

                    //create object to pass as CSS properties to tooltip
                    var cssOBJ = {
                            top: $this.closest('td').position().top,
                            left: $this.closest('td').position().left,
                            transform: 'scale(' + ($this.closest('td').outerWidth() / 600) + ', ' + ($this.closest('td').outerHeight() / 360) + ')',
                            transformOrigin: ''
                        },
                        originLeft = 0,
                        originTop = 0;

                    //if too close to the right-side
                    if (cssOBJ.left + 600 > $calendarWrapper.width()) {

                        cssOBJ.left = $calendarWrapper.width() - 600;
                        originLeft = ($this.closest('td').position().left - cssOBJ.left + $this.closest('td').width() / 2) / 600 * 100;

                    }

                    //if too close to the bottom
                    if (cssOBJ.top + 360 > $calendarWrapper.height()) {

                        cssOBJ.top = $calendarWrapper.height() - 360;
                        originTop = ($this.closest('td').position().top - cssOBJ.top + $this.closest('td').height() / 2) / 360 * 100;

                    }

                    if (originLeft > 0 || originTop > 0) {

                        cssOBJ.transformOrigin = originLeft + '% ' + originTop + '%';

                    }

                    //apply css to tooltip
                    $tooltip
                        .css(cssOBJ);

                    //remove old tooltips etc.
                    $calendarWrapper
                        .children('.tooltip, .view-day')
                        .trigger('close');

                    //add new tooltip
                    $calendarWrapper
                        .append($tooltip);

                    //focus tooltip
                    $tooltip
                        .focus();

                    //animate new tooltip into view
                    clearTimeout($calendarOverlay.data("timer"));

                    setTimeout(function () {

                        $calendarOverlay
                            .addClass("active");

                        $tooltip
                            .addClass('active')
                            .css({
                                transform: ''
                            });

                    }, 50);

                }

            }

        });


    //CLOSE TOOLTIPS ON <ESC>
    $(document).on("keydown", function (event) {
        if (event.which === 27) {
            $calendarWrapper.children(".tooltip, .view-day").trigger("close");
        }
    });

    //PRELOAD BANNER IMAGES
    for (let i = 0, l = $events.length; i < l; i++) {
        if ($events.eq(i).data('banner-img') !== $events.eq(i).data('square-img')) {
            $('<img />')[0].src = $events.eq(i).data('banner-img');
        }
    }

})(jQuery);
